import React from 'react';
import { CategoryFormData, DeadlineRule } from '../../types';
import DeadlineRuleEditor from '../DeadlineRuleEditor';
import sidePanelStyles from '../../../../../styles/SidePanel.module.css';
import buttonStyles from '../../../../../styles/Buttons.module.css';
import styles from '../../../../../styles/PointConfigurationTab.module.css';

interface SchemesTabProps {
  formData: CategoryFormData;
  deadlineRules: DeadlineRule[];
  onInputChange: (field: string, value: any) => void;
  onAddRule: () => void;
  onUpdateRule: (ruleId: string, field: string, value: any) => void;
  onRemoveRule: (ruleId: string) => void;
}

const SchemesTab: React.FC<SchemesTabProps> = ({ 
  formData, 
  deadlineRules,
  onInputChange,
  onAddRule,
  onUpdateRule,
  onRemoveRule
}) => {
  return (
    <div className={`${sidePanelStyles.tabContent} ${sidePanelStyles.active}`}>
      <div className={styles.schemesSection}>
        <div className={sidePanelStyles.sectionHeader}>
          <h4 className={sidePanelStyles.sectionTitle}>Point Scheme Configuration</h4>
          
        </div>

        <div className={sidePanelStyles.formGroup}>
          <label className={sidePanelStyles.formLabel}>
            Base Points <span className={sidePanelStyles.required}>*</span>
          </label>
          <input
            type="number"
            className={sidePanelStyles.formControl}
            value={formData.base_points}
            min="0"
            max="10000"
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              onInputChange('base_points', isNaN(value) ? 0 : value);
            }}
            required
          />
          <div className={sidePanelStyles.formHelp}>
            Default points awarded for completing a task in this category
          </div>
        </div>
        
        <div className={sidePanelStyles.formGroup}>
          <label className={sidePanelStyles.formLabel}>Deadline-based Point Rules</label>
          <p className={sidePanelStyles.formHelp}>
            Create rules for different time periods relative to task deadline
          </p>
          
          <div className={styles.customRulesSection}>
            <div className={styles.deadlineRulesList}>
              {deadlineRules.map((rule) => (
                <DeadlineRuleEditor
                  key={rule.id}
                  rule={rule}
                  onUpdate={onUpdateRule}
                  onRemove={onRemoveRule}
                />
              ))}
            </div>
            
            <button 
              type="button" 
              className={`${buttonStyles.btn} ${buttonStyles.btnPrimary}`}
              onClick={onAddRule}
            >
              <i className="bi bi-plus"></i> Add Custom Deadline Rule
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchemesTab;

